<template>
    <span class="cancellation-state-badge">{{ cancellationStateText }}</span>
</template>

<script setup lang="ts">
    import { CancellationState } from "@/data/model/Enums";
    import { trans } from "@/operator/localization/Trans";
    import { computed } from "vue";

    const props = defineProps<{
        cancellationState: CancellationState;
    }>();

    const cancellationStateText = computed(() => {
        const state = CancellationState[props.cancellationState];
        return trans.enums.cancellationState[state];
    });
</script>
